import merge from 'lodash/merge';
import DomainResource from './DomainResource';
import CoverageClass from './CoverageClass';
import CoverageCostToBeneficiary from './CoverageCostToBeneficiary';
import CodeableConcept from './types/CodeableConcept';
import Identifier from './types/Identifier';
import Reference from './types/Reference';
import Period from './types/Period';

export default class Coverage extends DomainResource {
    static __className = 'Coverage';

    __objectStructure = {
        identifier: [Identifier],
        status: String, // active | cancelled | draft | entered-in-error
        type: CodeableConcept,
        policyHolder: Reference,
        subscriber: Reference,
        subscriberId: String,
        beneficiary: Reference,
        dependent: String,
        relationship: CodeableConcept,
        period: Period,
        payor: [Reference],
        class: [CoverageClass],
        order: Number,
        network: String,
        costToBeneficiary: [CoverageCostToBeneficiary],
        subrogation: Boolean,
        contract: [Reference],
        /**
         * First Class extensions
         */
        claimId: String,
        medicareSecondaryIndicator: CodeableConcept,
        insurancePriority: CodeableConcept,
        patientOrAuthorizedSignature: String,
        acceptAssignment: String,
    };

    __objectDefaults = {
        type: new CodeableConcept({ coding: [] }),
        relationship: new CodeableConcept({ coding: [] }),
    };

    constructor(constructJson, className = 'Coverage') {
        super(constructJson, className);
        this.createAndPopulateStructure(this.__objectStructure, constructJson, this.__objectDefaults);

        this.originalObjJson = this.toJSON();
    }

    toJSON() {
        return merge(super.toJSON(this), this.getJsonForStructure(this.__objectStructure));
    }
}
